import { isEmpty } from 'lodash';

const mergeCustomFieldValues = (customFields = [], other) => {
  const otherCustomFields = other?.customFields || [];
  if (!isEmpty(otherCustomFields)) {
    otherCustomFields.forEach((item) => {
      const index = customFields.findIndex(
        ({ customFieldId }) => customFieldId === item.customFieldId,
      );
      if (index >= 0) {
        customFields.splice(index, 1, item);
      } else {
        customFields.push(item);
      }
    });
  }
  return customFields;
};

export const mergeRequirementFormData = (...items) => {
  const customFields = items.reduce(
    (customFields, item) => mergeCustomFieldValues(customFields, item),
    [],
  );
  const requirement = items.reduce(
    (requirement, item) => ({ ...(requirement || {}), ...(item || {}) }),
    {},
  );
  requirement.customFields = customFields;
  return requirement;
};
